import { useApiUrl, useCustomMutation } from 'admin';
import type { InspectionLink as InspectionLinkResponse } from 'api';
import { Button, Tooltip } from 'ui';
import { MobileScreenShare } from 'ui/icons';

export const InspectionLink = ({ inspectionId, disabled }: { inspectionId?: number; disabled: boolean }) => {
  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation<InspectionLinkResponse>();
  const tooltipText = disabled
    ? 'Only inspections with a grade have an inspection link'
    : 'Copy the inspection link to clipboard';

  const handleCopyInspectionLink = () => {
    mutate(
      {
        method: 'put',
        successNotification: () => {
          return {
            message: `Inspection link copied to clipboard.`,
            type: 'success',
          };
        },
        url: `${apiUrl}/inspections/v1/${inspectionId}/generate_inspection_link/`,
        values: {},
      },
      {
        onSuccess: (data) => {
          navigator.clipboard.writeText(data.data.inspection_url);
        },
      }
    );
  };

  return (
    <Tooltip title={tooltipText}>
      <div>
        <Button
          disabled={disabled}
          endIcon={<MobileScreenShare />}
          aria-label="copy inspection link"
          variant="secondary"
          onClick={handleCopyInspectionLink}
        >
          Inspection Link
        </Button>
      </div>
    </Tooltip>
  );
};
